<mat-toolbar class="p-0">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    @if (!hiddenNavbar && !rightNavbar) {
      <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    }

    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start baseline">
      <app-switch></app-switch>
    </div>
  </div>

  @if (!isMobile) {
    <button mat-icon-button (click)="getInfoBrain()" class="mr-12"><mat-icon class="icon">info</mat-icon></button>
  }

  @if (!isMobile) {
    <button mat-icon-button (click)="toggleVisibility()" class="mr-12"><mat-icon class="icon">lock</mat-icon></button>
  }

  <button
    mat-icon-button
    class="mr-12"
    (click)="toggleTheme()"
    [matTooltip]="isDark() ? 'Passa al tema chiaro' : 'Passa al tema scuro'"
    [attr.aria-label]="isDark() ? 'Passa al tema chiaro' : 'Passa al tema scuro'"
  >
    <mat-icon class="icon">{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

  <button
    mat-icon-button
    class="user-avatar-trigger mr-12"
    #userMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="userMenu"
    matTooltip="Il tuo profilo"
    aria-label="Apri il menu del profilo"
  >
    <span class="user-avatar">
      @if (fotoUrl) {
        <img [src]="fotoUrl" alt="" (error)="fotoUrl = null" />
      } @else {
        {{ iniziali }}
      }
    </span>
  </button>

  <button mat-icon-button class="mr-20" (click)="toggleSidebarOpen('quickPanel')">
    <mat-icon
      class="icon"
      [matBadge]="notifications.length"
      [matBadgeHidden]="!notifications.length"
      matBadgeColor="warn"
      aria-hidden="false"
    >
      notifications
    </mat-icon>
  </button>

  <input
    #fotoInput
    type="file"
    hidden
    accept="image/png,image/gif,image/jpeg,image/bmp"
    (change)="cambiaFoto($event)"
  />

  <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before" yPosition="below">
    <div class="user-menu-content">
      <div class="user-menu-avatar-wrap">
        <button
          type="button"
          class="user-avatar user-menu-avatar user-menu-avatar-edit"
          aria-label="Cambia foto profilo"
          [attr.aria-disabled]="isUploadingFoto"
          [attr.aria-busy]="isUploadingFoto"
          (click)="apriSelettoreFoto({ event: $event, input: fotoInput })"
        >
          @if (fotoUrl) {
            <img [src]="fotoUrl" alt="" (error)="fotoUrl = null" />
          } @else {
            {{ iniziali }}
          }
          <span class="user-menu-avatar-overlay" [class.is-loading]="isUploadingFoto">
            @if (isUploadingFoto) {
              <mat-spinner diameter="28" />
            } @else {
              <mat-icon>photo_camera</mat-icon>
            }
          </span>
        </button>
        @if (fotoUrl) {
          <button
            type="button"
            class="user-menu-avatar-remove"
            aria-label="Elimina foto profilo"
            [attr.aria-disabled]="isUploadingFoto"
            (click)="$event.stopPropagation(); eliminaFoto(userMenuTrigger)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>

      <div class="user-menu-name">{{ nomeCompleto }}</div>

      @if (socio?.tessera_andi; as tessera) {
        <div class="user-menu-detail">
          <span class="user-menu-detail-label">Tessera:</span>
          {{ tessera }}
        </div>
      }

      @if (socio?.sezione; as sezione) {
        <div class="user-menu-detail">
          <span class="user-menu-detail-label">Sezione:</span>
          {{ sezione }}
        </div>
      }

      <div class="user-menu-actions">
        <a
          mat-flat-button
          color="primary"
          class="user-menu-logout"
          routerLink="/logout"
          (click)="userMenuTrigger.closeMenu()"
        >
          <mat-icon>power_settings_new</mat-icon>
          Disconnetti
        </a>
      </div>
    </div>
  </mat-menu>
</mat-toolbar>
